import { useTranslation } from "@refinedev/core";
import Input from "components/input";
import { Label } from "components/label";
import { IAdditionalSetupForm, ISimpleEventDetail } from "interfaces";
import { get } from "lodash";
import { useFormContext } from "react-hook-form";

export const Einvoice = ({
  isEdit,
}: {
  isEdit: boolean;
  eventDetailData: ISimpleEventDetail;
}) => {
  const { translate } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext<IAdditionalSetupForm>(); // retrieve all hook methods

  return isEdit ? (
    <div className="box-container p-4 sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
        <div className="col-span-full">
          <Label
            id="einvoice.label_event_on_einvoice"
            name={translate(
              "eventSetup.additionalSetup.einvoice.labelEventOnEinvoice",
            )}
            required
          />
          <Input
            id="einvoice.label_event_on_einvoice"
            type="text"
            placeholder={translate(
              "eventSetup.additionalSetup.einvoice.labelEventOnEinvoice",
            )}
            error={get(errors, "einvoice.label_event_on_einvoice")}
            {...register("einvoice.label_event_on_einvoice")}
          />
          {get(errors, `einvoice.label_event_on_einvoice`, "") ? (
            <p className="error-text">
              <span className="font-medium">
                {get(errors, `einvoice.label_event_on_einvoice.message`, "")}
              </span>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
